const ReviewIconSvg = ({
  width = 16,
  height = 16,
  viewBox = '0 0 16 16',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M8 4L8.956 5.8515L11 6.1485L9.5 7.5L10 9.5L8 8.375L6 9.5L6.5 7.5L5 6.1485L7.1 5.8515L8 4Z"
        fill="currentColor"
      />
      <path
        d="M8.868 15L8 14.5L10 11H13C13.1314 11.0002 13.2615 10.9745 13.3829 10.9243C13.5043 10.8741 13.6146 10.8004 13.7075 10.7075C13.8004 10.6146 13.8741 10.5043 13.9243 10.3829C13.9745 10.2615 14.0002 10.1314 14 10V4C14.0002 3.86862 13.9745 3.7385 13.9243 3.61708C13.8741 3.49567 13.8004 3.38535 13.7075 3.29245C13.6146 3.19955 13.5043 3.1259 13.3829 3.07572C13.2615 3.02553 13.1314 2.9998 13 3H3C2.86862 2.9998 2.7385 3.02553 2.61708 3.07572C2.49567 3.1259 2.38535 3.19955 2.29245 3.29245C2.19955 3.38535 2.1259 3.49567 2.07572 3.61708C2.02553 3.7385 1.9998 3.86862 2 4V10C1.9998 10.1314 2.02553 10.2615 2.07572 10.3829C2.1259 10.5043 2.19955 10.6146 2.29245 10.7075C2.38535 10.8004 2.49567 10.8741 2.61708 10.9243C2.7385 10.9745 2.86862 11.0002 3 11H7.5V12H3C2.46957 12 1.96086 11.7893 1.58579 11.4142C1.21071 11.0391 1 10.5304 1 10V4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V10C15 10.5304 14.7893 11.0391 14.4142 11.4142C14.0391 11.7893 13.5304 12 13 12H10.5825L8.868 15Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ReviewIconSvg;
